en:
  acceptInvite:
    continueWithFacebookText: 'Or, continue with Facebook'
    firstNameErrorRequired: First name cannot be empty
    firstNameLabel: First name
    firstNamePlaceholder: Enter your first name
    helloFNameText: 'Hello {{fName}}'
    lastNameErrorRequired: Last name cannot be empty
    lastNameLabel: Last name
    lastNamePlaceholder: Enter your last name
    otpLabel: Enable 2FA
    otpSecretErrorRequired: This field is required.
    otpSecretLabel: Please scan QR code with authenticator app and verify
    otpSecretPlaceholder: Code provided by authenticator app
    passwordConfirmationErrorRequired: Password confirmation cannot be empty
    passwordConfirmationLabel: Password confirmation
    passwordConfirmationPlaceholder: Confirm your password
    passwordError: 'Password {{passwordError}}'
    passwordErrorRequired: Password cannot be empty
    passwordLabel: Password
    passwordPlaceholder: Enter your password
    passwordShouldBeStrong: 'Password should be at least 8 characters, should not be a common word, and should include upper and lower case letters, numbers and symbols.'
    passwordShouldMatchError: Password should match password confirmation
    provideYourDetailsText: 'Please provide your details to continue:'
    signInWithFacebookBtn: Sign in with Facebook
    signUpBtn: Sign up
    welcomeToSRText: Welcome to Shuttlerock
  accountSettings:
    accountSettingsUpdated: Account settings updated.
    clientNameLabel: Client Name
    clientNamePlaceholder: Client Name
    edit: Edit
    emailLabel: Email
    emailPlaceholder: Email
    emailemail: This should be a valid email.
    emailrequired: This field is required.
    firstNameLabel: First Name
    firstNamePlaceholder: First Name
    firstNamerequired: This field is required.
    lastNameLabel: Last Name
    lastNamePlaceholder: Last Name
    lastNamerequired: This field is required.
    loading: Loading...
    notificationValidatedBody: 'Your confirmation has been resent to {{ email }}.'
    notificationValidatedHeader: Email Resent
    notificationWarningBody: "We've sent an email to the address listed below, please confirm to activate your account. Didn't receive an email? <1>Resend Confirmation</1>"
    notificationWarningHeader: Please confirm your email account
    passwordLabel: Password
    reset: Reset
    submit: Save Changes
    title: Account Settings
  accountType:
    subscription: Subscription
    unrestricted: Unrestricted ordering
  advertListPage:
    addAdvert: Add Another Concept
    modalDeleteCancelButton: Cancel
    modalDeleteConfirmationButton: Delete Concept
    modalDeleteConfirmationText: Are you sure you want to delete this Concept? Once you delete your Concept you won't be able to get it back.
    modalDeleteConfirmationTitle: 'Delete: Concept {{name}}'
    successDeleteContent: Your advert has been successfully deleted.
    successDeleteHeader: Advert Deleted
  conceptPanel:
    submitToProduction: Submit to production
    designersLabel: Designer(s)
    designersPlaceholder: 'Select Designer {{artDirector}}'
    designersUpdated: Designer(s) updated
    productionMetadataErrorUpdate: Production metadata could not be updated. Please refresh and try again.
    no: No
    notes: Notes
    notesUpdated: Notes updated
    untitledConceptName: 'Untitled Concept'
    primaryLanguageLabel: Primary Language
    primaryLanguageErrorLoading: Failed to load languages, please try again
    primaryLanguageErrorRequired: A primary language is required
    primaryLanguageErrorUpdate: Failed to update primary language, please try again
    marketShortLabel: Market
    targetAudience: 'Target Audience:'
    targetAudienceInterests: 'Interests:'
    targetAudienceGenderAll: 'All Genders'
    targetAudienceGenderFemale: 'Females'
    targetAudienceGenderMale: 'Males'
    targetAudienceLifestyle: 'Lifestyle:'
    targetAudienceLocation: 'Location:'
    yes: Yes
    localisation:
      localisationInstructions: Localization Instructions
      localisationAssets: Localization Assets
      noInstructionsProvided: (No instructions provided)
      primaryTargetMarket: Primary Target Market (Source Locale)
      additionalTargetMarkets: Additional Target Markets
      localiseCopy: Localize Copy
      localiseAsset: Localize Asset
      localiseVoiceover: Localize Voiceover
      additionalInstructions: Additional Instructions
      translationStringsSheetURL: Translation strings sheet URL
    deliverableTable:
      baseDeliverables: 'Additional Format Deliverables ({{count}}/{{total}})'
      copyFilenameError: 'Failed to copy filename to clipboard'
      copyFilenameSuccess: 'File name copied to your clipboard!'
      details: Details
      dimension: Dimension
      duration: Duration Category
      expressProject: Express Project
      filename: File name
      format: Format
      hero: Hero
      variations: Variations
      variation: 'Variation {{index}} - {{name}}'
      heroDeliverables: 'Hero Deliverables ({{count}}/{{total}})'
      viewLink: View
    workflow:
      error:
        update: Failed to update substage
        validation: Failed to update stage due to validation errors
    ugcInformation:
      sectionLabel: UGC ideation and creator brief
      alert:
        title: For reference only
        content: This content was curated for UGC creators and the ideation team, and only provides additional context for hero production.
      brandDetails:
        brandDetailsLabel: Brand details
        productPositioningLabel: 'Brand / product positioning:'
        socialChannelsLabel: 'Social channels:'
      conceptDirectionLabel: UGC concept direction
      approachLabel: Approach
      deliverableLabel: UGC Deliverable
      creatorPreferences:
        preferencesLabel: Creator preferences
        ageLabel: 'Age:'
        genderLabel: 'Gender:'
        ethnicityLabel: 'Ethnicity:'
        locationLabel: 'Location:'
        hobbiesLabel: 'Interests and hobbies:'
        extraRequirementsLabel: 'Additional requirements:'
      procurementLabel: Product procurement
      voiceOverInstructionsLabel: Script or Voice-over instructions
      languageLabel: Language
      additionalInstructionsLabel: Additional creator instructions
      hookLabel: The hook
      doAndDontLabel: Dos and don’ts
      legalRequirementsLabel: Legal Requirements
      sellingPointsLabel: Unique selling points
    ugcBrandAssetsLabel: UGC Brand Assets
    ugcReferenceAssetsLabel: UGC Reference Assets
    ugcDeliverablesLabel: UGC Deliverables
  advertsSummary:
    duration: '({{length}} seconds)'
    edit: Edit
    noVariations: No Variations
    orderSummary: ORDER SUMMARY - FULL ORDER
    variations_one: '{{count}} Variation'
    variations_other: '{{count}} Variations'
    wouldYouLike: Would you like to add another Advert?
  aiModels:
    label: Preferred AI models
    category:
      IMAGE: Images
      VIDEO: Video
      AUDIO: Audio
      MUSIC: Music
      VOICE: Voice-over
    model:
      all: Any AI model
      none: None
      default: default
  alert:
    goBack: Go Back
    guestThanksReturnToSignInBtn: Return to Sign in
    notFoundPageNotFoundText: The page you are looking for could not be found.
    notFoundSupportEmailText: 'Did you follow a link from somewhere else on this site or from another website? If so, please email us at {{supportEmail}} so we can fix it.'
    notFoundTitle: Page Not Found
    oopsOhNoTitle: Oh No!
    oopsSomethingWentWrongText: Something went wrong.
    oopsTryAgainLaterText: "Please try again later. If this problem isn't fixed in a couple of hours, please contact our support team."
    orderThanksHomeButton: Home
    orderThanksText: Your project has been submitted and our designers will begin work once your brief has been reviewed.
    orderThanksTitle: Thank you
    orderThanksTrackYourOrderButton: Track your Project
    v1BriefNotExistsText: 'The details of your project no longer exist in Shuttlerock Cloud. Please contact your Creative Specialist for a copy of your brief, if required.'
  assetPicker:
    audio: Audio Files
    brand: Brand Guideline Files
    browseFiles: browse files
    compressed: Zip Files
    dropFiles: Drop your files here
    font: Font Files
    logo: Logo Files
    music: Audio Files
    placeholder: Drop files here or
    stills: Images
    uploaderMaxFiles: 'We are sorry the maximum asset upload for this Product is {{count}}'
    uppyError: There was an issue with the file(s) you tried to upload
    video: Video Files
  assetUploader:
    notesPlaceholder: Add notes about this file
    preferredFileTypes: 'Preferred file types:'
  assetsForm:
    assetUploadError: There was a problem when loading your files. Please try again or contact support.
    brandFontSupportedTypes: 'Supported file types: .otf, .ttf, .fnt, .ttc, and .woff'
    brandFontTitle: Brand Font(s)
    brandGuidelinesSupportedTypes: 'Supported file types: .png, .jpg, .jpeg, .psd, .ai, .eps, .svg and .pdf'
    brandGuidelinesTitle: Brand Guidelines
    brandLogoNOTSupportedTypes: .tif and .tiff are not supported by our uploaders
    brandLogoSupportedTypes: 'Supported file types: .png, .jpg, .jpeg, .psd, .ai, .eps, .tif, .tiff and .svg'
    brandLogoTitle: Brand Logo(s)
    brandMusicInformation: 'If no music is provided, Shuttlerock will select and use suitable music.'
    brandMusicSupportedTypes: 'Supported file types: .wav, .mp3, .aiff, .m4a, .flac, .alac, .aac and .wma'
    brandMusicTitle: Music File(s)
    cancelBtn: Back
    fontLabel: Font
    guidelinesLabel: Guidelines
    instructions: 'Please upload any logos, fonts, and brand guidelines that we need to create your videos. Where possible provide the highest resolution / size possible.'
    logoLabel: Logo
    minimizeBtnLabel: Minimize
    musicLabel: Music
    optional: Optional
    preferred: preferred
    requiredInformation: '* Essential'
    sectionInstructions: Upload your brand assets
    submitBtn: Next
    supportedFileTypes: 'Supported files types:'
    title: Brand Assets
    viewAllBtnLabel: View All
    whatToUpload: What to upload
  authForm:
    continueWithFacebook: Continue with Facebook
    continueWithGoogle: Continue with Google
    emailErrorEmail: This should be an email
    emailErrorRequired: This field is required.
    emailLabel: Email Address
    emailPlaceholder: Email Address
    facebookAuthorizationFailed: Facebook authorization failed or canceled
    forgotPasswordLink: Forgot your password?
    getStarted: Get started
    googleAuthorizationFailed: Google authorization failed or canceled
    heading: Sign In
    notAUser: 'Not a user? '
    otpAttemptLabel: One time password
    otpAttemptPlaceholder: Enter OTP from authenticator
    otpLabel: 2FA
    passwordErrorRequired: This field is required.
    passwordLabel: Password
    passwordPlaceholder: Password
    passwordResetSuccessMessage: 'Your password has been reset, please sign in with your new password.'
    rememberMeLabel: Remember me
    signInBtn: Sign in
    signInError: There seems to be an issue. Please try again later or contact support.
    signInWithEmail: Sign in with Email
    signInWithFacebookBtn: Sign in with Facebook
  brandAssets:
    brandNotesLabel: Are there any creative or legal requirements you'd like us to keep in mind for your brand?
    brandNotesPlaceholder: Type here
    formDescription: 'Upload your logo, fonts, brand guidelines, etc here. Let us know how best to represent your brand.'
    formTitle: Brand Assets
    next: Next
    reviewMyOrder: Review My Order
    save: Save & Exit
    selectedLogosErrorRequired: Please upload at least one logo file
    selectedLogosLabel: Please upload your brand logo(s)
    selectedOthersHelp: Shuttlerock will select and use suitable audio and/or fonts if not provided.
    selectedOthersLabel: 'Please upload your fonts, brand guidelines & audio files'
  brandAssetsManagement:
    title: "{{name}}'s Brand Assets"
  briefTracker:
    brandAssets: Brand Assets
    campaignDetails: Campaign Details
    summary: Summary
  clientForm:
    accountTypeErrorRequired: Please select account type
    accountTypeLabel: How will ordering be managed for this client?
    accountTypeDescriptionUnrestricted: 'There are no restrictions on ordering for this account type'
    cancelBtn: Cancel
    cannotBeEditedWarning: Please note - this cannot be edited once created
    clientCreated: Client created.
    clientPartnersErrorRequired: This field is required.
    clientPartnersLabel: Client Partners
    clientPartnersPlaceholder: Select client partner(s)
    creativeSpecialistsErrorRequired: This field is required.
    creativeSpecialistsLabel: Creative Specialists
    creativeSpecialistsPlaceholder: Select creative specialist(s)
    descriptionLabel: Description
    descriptionPlaceholder: Enter a brief sentence describing the client
    facebookUrlLabel: Facebook
    facebookUrlPlaceholder: Enter Facebook link
    hubspotIdErrorRequired: This field is required.
    hubspotIdLabel: Hubspot Company ID
    hubspotIdPlaceholder: Enter the client's company hubspot ID
    instagramUrlLabel: Instagram
    instagramUrlPlaceholder: Enter Instagram link
    loggedOutDownloadingLabel: Allow logged out users to download creatives
    nameCannotBeEditedWarning: Please note - this cannot be edited once an order has been placed
    nameErrorRequired: This field is required.
    nameLabel: Client Name
    namePlaceholder: Enter the name of the client
    'no': 'no'
    otherUrlLabel: Other
    otherUrlPlaceholder: 'Eg. https://www.example.com/'
    pinterestUrlLabel: Pinterest
    pinterestUrlPlaceholder: Enter Pinterest link
    platformsErrorRequired: This field is required.
    platformsLabel: Please select the platform(s) available for custom ordering
    platformsPlaceholder: Select Platforms
    preApprovalDownloadingLabel: Allow client to download creatives prior to approval
    regionErrorRequired: This field is required.
    regionLabel: Sales Territory
    regionPlaceholder: Select a Sales Territory
    sectionClientDetails: Client details
    sectionDownloads: Downloads
    sectionOrdering: Ordering
    sectionShuttlerockDetails: Shuttlerock details
    submitBtn: Submit
    successUpdateBody: '{{clientName}} has been successfully updated.'
    successUpdateHeader: Client updated
    tiktokUrlLabel: TikTok
    tiktokUrlPlaceholder: Enter TikTok link
    twitterUrlLabel: Twitter
    twitterUrlPlaceholder: Enter Twitter link
    verticalLabel: Vertical
    verticalPlaceholder: Please select
    websiteUrlLabel: Website
    websiteUrlPlaceholder: Enter website link
    'yes': 'Yes'
    youtubeUrlLabel: YouTube
    youtubeUrlPlaceholder: Enter YouTube link
  clientList:
    actionBtnAriaLabel: Open Client Action Menu
    actionsLabel: Actions
    assetsBtn: Brand Assets
    clientCopiedContent: 'The Client ID for {{clientName}} has been added to your clipboard'
    clientCopiedTitle: Client ID Copied!
    clientNameLabel: Client Name
    clientSearchLabel: Search
    copyClientId: Copy Client ID
    editBtn: Edit
    emptyTableMessage: There are no clients to display. Click the 'New Client' button above to add a new client.
    header: '{{name}} Clients'
    manageUsersBtn: Manage Users
    newClientBtn: New Client
    ownerEmailLabel: Owner Email
    salesTerritoriesPlaceholder: All Sales Territories
    salesTerritoryLabel: Sales Territory
  colorpicker:
    close: Close
    notesPlaceholder: Add notes about this colour
  common:
    loadMoreBtn: Load more
  confirmOrderErrorModal:
    description: Come back to the Production Brief when you're ready to resubmit.
    return: Return to Production Brief
  confirmOrderModal:
    approveBriefToastMessage: 'The brief has been approved, and the Google Drive asset folders are generating. The order will then move to In Progress.'
  datepicker:
    applyCustomDate: Apply custom date
    phrases:
      close: Close
      datepickerEndDateLabel: 'End date:'
      datepickerEndDatePlaceholder: Select
      datepickerStartDateLabel: 'Start date:'
      datepickerStartDatePlaceholder: Select
      endDateAriaLabel: End date
      endDatePlaceholder: End date
      resetDates: Reset dates
      startDateAriaLabel: Start date
      startDatePlaceholder: Start date
  deliverableState:
    approved: Approved
    expired: Expired
    internally_rejected: Internally Rejected
    pending_delivery: Pending Delivery
    client_review: Client Review
    internal_review: Internal Review
    rejected: Rejected
  dimensionInput:
    addBtnLabel: Add
    dimensionAlreadyExistsError: These dimensions already exist
    heightLabel: H
    heightLessThanError: 'Height should be less than {{max}}'
    heightMoreThanError: 'Height should be more than {{min}}'
    heightRequiredError: Height is required
    information: Please enter your required dimensions in pixels.
    widthHeightLessThanError: 'Width/Height should be less than {{max}}'
    widthHeightMoreThanError: 'Width/Height should be more than {{min}}'
    widthHeightRequiredError: Width/Height are required
    widthLabel: W
    widthLessThanError: 'Width should be less than {{max}}'
    widthMoreThanError: 'Width should be more than {{min}}'
    widthRequiredError: Width is required
  editCopyModal:
    callToAction: Call-to-action
    ctaDescription: Drives the user to a specific action
    mockupDescription: 'This isn’t a mockup for your project, the purpose of this image is to visually show how ad copy should be structured.'
    mockupTitle: Video Mockup Example
    primaryCopy: Primary copy is the core message you want to convey/deliver
    saveAndClose: Save & close
    saveAndOpenNext: Save & open next variation
    secondaryCopy: Secondary message highlights the benefit of the product
    tertiaryCopy: Tertiary copy supports your primary and secondary messages.
  emailConfirmationResent:
    body: 'We’ve resent your confirmation email, please confirm to activate your account. Didn’t receive an email? Check your email address in <1>Account Settings</1>'
    heading: Email resent
  emailConfirmed:
    body: 'Thank you for confirming your email {{email}} with us.'
    heading: Email Confirmed
  error:
    errorLabel: Error
    gqlError: 'Sorry, something went wrong. Please try again later.'
    invalidUrl: This should be valid URL.
    networkIssue: 'Sorry, something went wrong with our network. Please try again later.'
    okButtonText: Ok
    oopsIntroText: Oops! An error occured!
    orderNotFoundToastMessage: Use the live chat to speak with a Shuttlerock Cloud Specialist or email <1> help@shuttlerock.com </1>
    orderNotFoundToastTitle: You don't have access to this brief
  exportSpinner:
    close: Close
    exportCompleted: Export finished
    exportSpinnerText: 'Exported {{successCount}} of {{totalCount}} deliverables'
    facebookGenericErrorMessage: 'Export failed. If you continue to have problems, please <2>contact support</2>.'
  facebookDetails:
    checkYourDetails: Check your details are correct
    content: We’ve pulled this information from your Facebook account. You can make changes to the information below or edit it later under Account Settings.
    edit: Edit
    emailLabel: Email
    emailPlaceholder: Email
    emailemail: This should be a valid email.
    emailrequired: This field is required.
    firstNameLabel: First Name
    firstNamePlaceholder: First Name
    firstNamerequired: This field is required.
    lastNameLabel: Last Name
    lastNamePlaceholder: Last Name
    lastNamerequired: This field is required.
    loading: Submitting...
    noEmailPermission: You have opted to not share your email with Shuttlerock. Please add an email so we can send important project updates and check that we’ve got the correct information for your account.
    submit: Submit & Continue
    title: 'Your Details:'
    welcomeToSRText: Welcome to Shuttlerock
  fileType:
    audio: Audio
    brand: Brand
    compressed: Zip
    font: Font
    logo: Logo
    stills: Images
    video: Video
    brand_logo: Brand Icon
    reference: Reference
    text_field: Supporting Files
  footer:
    privacy: Privacy
    support: Support
    supportRequest: 'Support Request {{name}}'
    terms: Terms
  general:
    cancel: Cancel
    confirm: Confirm
    create: Create
    delete: Delete
    dimension: '{{width}}W : {{height}}H'
    directDownloadSuccess: Download started.
    disclaimer: 'By continuing, you agree to Shuttlerock’s <1> Privacy Notice</1>, <3>Terms and Conditions of Use</3>.'
    download: Download
    edit: Edit
    error: Error
    googleDrive: Google Drive
    hero: Hero
    link: Link
    loading: Loading
    next: Next
    'no': 'No'
    onBeforeUnloadMessage: Changes that you made may not be saved.
    pleaseEnterBetween: 'Please enter a value between {{min}} and {{max}}'
    pleaseEnterWholeNumber: Please enter a whole number
    previous: Previous
    review: Review
    save: Save
    saveAndExit: Save & Exit
    search: Search
    select: Select
    success: Success!
    update: Update
    view: View
    viewAll: 'View all {{name}}'
    viewFullList: 'View full list ({{ number }})'
    viewLess: View less
    'yes': 'Yes'
  header:
    briefSummaryHeaderText: Brief Summary
    demoSiteWarning: DEMO ONLY - PLEASE NOTE ORDERS WILL NOT BE PROCESSED
    editClientHeaderText: Edit Client
    newClientHeaderText: Create Client
    newOrderHeaderText: Create Project
    orderDeliverableUploadHeaderText: Upload Deliverables
    orderFormHeaderText: Order Form
    orderInternalDeliverableListHeaderText: Deliver Creatives
    signInLink: Sign in
    signInText: Already a user?
    userInviteHeaderText: Invite User
    usersListHeaderText: '{{name}} Users'
  inputElement:
    inputPlaceholder: Type your answer here...
  instantAnswer:
    checkboxValuesNumber: 'The number of options selected should be not less than {{minSelected}} and not greater than {{maxSelected}}.'
    requiredFieldText: This field is required
  formatLengths:
    durationSelectOptionsTitle: Durations
  lightbox:
    aviNotSupported: Unfortunately we cannot play AVI files on this browser.
    dimensionsLabel: 'Dimensions:'
    downloadAssets: Download Asset
    durationLabel: 'Duration:'
    fileSizeLabel: 'File Size:'
    fileTypeLabel: 'File Type:'
    resolutionLabel: 'Resolution:'
    staticDuration: Static
  mainMenu:
    accountSettings: Account Settings
    signOut: Sign Out
    support: Support
  objectives:
    brand_awareness: Brand Awareness
    consideration: Consideration
    direct_response: Direct Response
    full_funnel: Full Funnel
    unknown: Unknown
  orderAdvertAnswers:
    assetsErrorRequired: Please select at least one asset for this Ad Pack
    assetsLabel: Upload and/or click on the assets you want to use in this concept
    assetsTooltip: 'Asset selection recommendations<br/><strong>Static:</strong> 1 image<br/><strong>6 second video:</strong> 1 video or 1 image<br/><strong>15 second video:</strong> 1 video and/or 5 images<br/><strong>30 second video:</strong> 1 video and/or 15 images<br/>'
    autoSaveInfo: We auto-save your progress
    clickToAdd: click to add assets across the preview box
    conceptVariationTitle: 'Concept Details: {{advertName}} - Concept {{ variationNumber }} '
    formDescription: Select the assets and provide the copy that our designers will use to create your concept.
    formTitle: 'Concept Details: {{name}}'
    languagesErrorRequired: This is a required question
    languagesLabel: 'Select the languages you require translations for ({{numLanguages}} required)'
    languagesPlaceholder: Language
    languagesVariationInformation: You will be asked for your translated copy at a later stage.
    noResponseText: None
    noVariations: No Variations
    numOfLanguagesError: 'You must select {{numLanguagesToSelect}} languages'
    objectiveErrorRequired: This is a required question
    objectiveLabel: Which best describes your campaign objective?
    objectiveShortLabel: Campaign Objective
    overview: Overview of video specs
    productOrServiceShortLabel: Product / Service
    required: Answer to this question is required
    submit: Submit
    submitting: Loading...
    useRootAdvertAnswersFalse: Change ad copy
    useRootAdvertAnswersLabel: You can choose to keep your copy the same for this variation or provide new copy.
    useRootAdvertAnswersTrue: '*Keep ad copy the same'
  orderAdvertList:
    accessDeniedMsg: Orders are not able to be edited once submitted.<br /> Contact our support team if you require changes.
    heading: Order Details
    orderSaved: Your order has been saved
    modalDeleteCancelButton: Cancel
    modalDeleteConfirmationButton: Delete Concept
    reviewMessage: Once you start your brief you won’t be able to edit your order details.
    save: Save & Exit
    startBrief: Start Brief
    subHeading: Review your details before submitting your order.
    totalOrderDeliverables: Order Deliverables
  orderAdvertNew:
    orderAdvertFormHeaderText: Custom Ordering
    platformRequired: Please select at least one platform
    reviewBtn: Review Order
  orderAdvertNewSummary:
    advertSummaryTitle: advert summary
  orderAnswersEdit:
    assetsDescription: 'Please upload all image, video, audio and other assets you would like to use in this order. <br/> Campaign assets can also be uploaded on subsequent pages.'
    assetsErrorRequired: Please upload at least one campaign asset file
    assetsHelp: You will select from these assets when briefing each ad pack.
    assetsLabel: Campaign Assets
    autoSaveInfo: We auto-save your progress
    baseLanguageErrorRequired: This field is required
    baseLanguageLabel: Choose the primary language for your project
    baseLanguagePlaceholder: Select language
    campaignQuestionsTitle: Campaign questions
    formDescription: Tell us your campaign goals to ensure our designers create ads that get the right results.
    formTitle: Campaign Details
    languageTooltip: The primary language will be used for all assets before translations are applied (if relevant).
    required: Answer to this question is required
  orderAssetEdit:
    submitBtn: Save & Continue
  orderBriefAnswerList:
    label:
      assetSources: Supplemented Assets
    assetSources:
      supplementAssets: 'Supplement provided assets with:'
      stockAssets: Stock assets
      website: Any assets from my brand guidelines, website or social platforms linked above
      aiEnhanced: AI-enhanced assets
      none: Only use the assets I provide
    utility:
      assistant: Assistant
      notes: Notes
      summary: Summary
    STATIC: Static
    actionsSave: Save & Exit
    actionsSubmit: Submit Brief
    additionalDetails: Additional Instructions
    additionalNotes: Additional Notes
    artDirectorLabel: Art Director
    artDirectorUpdated: Art Director updated
    assetNotes: Asset Notes
    assetsZipGeneratingTooltip: The asset zip is generating
    audio: Audio
    base: Base
    baseCopyTranslationLabel: 'Base Copy - {{language}}: '
    brandAssets: Brand Assets
    brandDescription: Brand description
    brandName: Brand
    brandPersonality: Brand personality
    brandRequirements: Legal and creative requirements
    briefCsReviewAlertTitle: This brief is currently in CS Review and can only be approved once it has been moved into Production Review.
    briefCsReviewInformation: To move a brief to Production Review, navigate to the brief and click the ‘Submit to Production Review’ button.
    briefSubmitted: 'This brief has been submitted and can no longer be edited. If you need to update the brief, please contact your Creative Strategist'
    briefUgcAlertTitle: This brief has UGC requirements, and is currently in {{state}}.
    briefUgcInformation: This can only be moved to Production review once UGC production is complete.
    campaignDetails: Campaign Details
    channels: Channels
    clientAndBrandDetails: Client & Brand Details
    clientDescription: Client description
    clientName: Client
    collapseAll: Collapse All
    disclaimer: Disclaimer
    expandAll: Expand All
    conceptIdea: Concept Idea
    conceptBasics: Basics
    conceptVariation: 'Concept Variation {{ index }}'
    confirmOrderBtnLabel: Approve Brief
    confirmOrderCancelBtnLabel: Cancel
    confirmOrderModalTitle: Are you sure you want to approve this brief?
    confirmSubmitOrderModalInformation: "<0>Once you click <1>Submit</1>, you won't be able to edit the brief any more.</0>"
    confirmSubmitOrderModalTitle: Are you sure?
    copyFilenameError: 'Failed to copy filename to clipboard'
    copyFilenameSuccess: 'File name copied to your clipboard!'
    details: Details
    detailsLinkLabel: View details
    dimension: Dimension (px)
    downloadAssets: Download Assets
    editLinkLabel: Edit
    editDetailsBtnLabel: Edit Details
    editNotesBtnLabel: Edit Notes
    editNotesClickOutside: Click outside the text area to save your notes
    editNotesPlaceholder: Click the edit button to add notes to this area. When you are done you can click anywhere outside the text box to save your notes
    fileName: File name
    group: Group
    internalNotesOnly: Internal Only Notes
    projectLevelQuestions: Project level questions
    languageBaseLabel: 'Language:'
    languageLabel: Select the languages you require translations for
    languagesVariationInformation: You will be asked for your translated copy at a later stage.
    languagesVariationInformationTitle: Translation Variation
    logo: Logo
    notesUpdated: Notes updated
    orderDetails: Project Details
    orderName: 'Project Name:'
    projectDetailsSavedSuccess: Project details saved
    projectDetails: Project Details
    projectNotes: Project Notes
    orderNotificationInformation: 'You will automatically receive all email updates about this project, along with the assigned Client Partner(s) and Creative Specialist(s)'
    orderNotificationTitle: Who should receive notifications when this project is ready?
    platformSpecifics: Platform Specifics
    productionBrief: Production Brief
    productionNotesPlaceholder: ' '
    productionTranslationLabel: 'Production Translation: '
    projectOverviewBtn: Project Overview
    region: Region
    reviewYourDetails: Review your brief details before submitting. Once you submit you won’t be able to edit the brief any more.
    saveNotes: Save Notes
    messaging: Messaging
    selectedAssets: Assets
    submitBtn: Submit
    submittedDateLabel: 'Submitted Date:'
    delivery:
      deliveryDueDateLabel: 'Next Delivery:'
      deliveryDueDateLinkLabel: Learn how
      nextDeliveryTooltip: '<0>{{linkText}}</0> this is calculated'
      changeDateLabel: Change date
      adjustedDeliveryLabel: 'Adjusted Delivery: '
      reasonLabel: Reason for adjusted delivery
      reasonPlaceholderLabel: Search or enter a reason
      requiredLabel: Required
      saveBtnLabel: Save
      toast:
        success: Next delivery adjusted
        saveError: Save Error
      reason:
        briefClarification: Brief Clarification Required
        complexDeliverables: Complex Deliverables
        complexRevision: Complex Revision
        storyboard: Requires Storyboard
        creativeRework: Creative Re-work
        midProductionChange: Mid-Production Change Request
        expeditedProject: Expedited Project
        splitDelivery: Split Delivery
        workingFileTat: Working File TAT
        specialFormat: Special Format Bespoke Timeline
        regionalHoliday: Regional holiday (Client)
    summaryTitle: Brief Summary
    tableDetails: Details
    tableDimension: Dimension (px)
    tableLength: Max Duration
    tablePlatform: Platform
    totalDeliverables: 'Total Deliverables: {{count}}'
    totalOrderDeliverables: Total Order Deliverables
    translation: '{{ language }} Translation'
    updateTranslationBtnLabel: Translate Copy
    updateTranslationSuccessMessage: Translations have been updated
    updateTrelloCardBtnLabel: Update Trello
    updateTrelloSuccessMessage: Trello Card has been updated
    updatingTrelloBtnLabel: Updating...
    urlFacebook: Facebook
    urlInstagram: Instagram
    urlOther: Other
    urlTwitter: Twitter
    urlWebsite: Website
    urlYoutube: YouTube
    verticalName: Vertical
    voiceOver: 'Voice Over'
    websites: 'Client Channels: '
  orderDeliverableList:
    adverts: Concepts
    actionFilterBtnLabel: 'Filter ({{totalFilters}})'
    Advertiser: Advertiser
    alphaRevisionModalTitle: Submit Revisions?
    alphaRevisionModalBody: You will receive an email when your creative is ready to review. During this time no further revisions can be added.
    alphaRevisionModalBodyInternal: The project will be sent back to our designers and delivery to the client will be delayed. Please move the Trello card to Revision Needed.
    csat:
      reasonQuality: Creative quality did not meet our expectations
      reasonTurnaround: Turnaround times were longer than expected
      reasonInstructions: Brief or Revision instructions were not followed
      reasonCommunication: CSM support or communication was poor
      reasonPlatform: There were issues with the Shuttlerock platform
      reasonOther: Other (please specify)
    quickFixDialog:
      title: Ready When You Are
      contentExpressDesign_one: Your {{count}} revision will be completed within <strong>4 hours</strong> using our express design service! <0>
      contentExpressDesign_other: Your {{count}} revisions will be completed within <strong>4 hours</strong> using our express design service! <0>
      tooltipExpressDesign: If your revisions have been miscategorised you'll be notified and our standard turnaround times will apply
      contentReceiveEmail: You'll receive an email once your creative is ready to review.
      buttonCancel: Cancel
      buttonSubmit: Submit Revisions
    projectRatingReasonLabel: What is the reason you gave this answer?
    projectRatingReasonPlaceholder: Choose an option
    projectRatingCommentLabel: Great! Is there anything you would like us to know?
    projectRatingCommentPlaceholder: Would you like to elaborate?
    projectRatingDialogTitle: Congratulations on approving your project
    projectRatingDialogContentTitle: 'How satisfied are you with this project? <0>'
    projectRatingDialogLowSatisfaction: 'Not at all <br /> satisfied'
    projectRatingDialogModerateSatisfaction: 'Moderately <br /> satisfied'
    projectRatingDialogHighSatisfaction: 'Completely <br /> satisfied'
    projectRatingDialogTooltip: Your rating will help us create the best Shuttlerock experience for you
    projectRatingDialogValidation: Please choose an option to continue
    projectRatingDialogCancel: Cancel
    projectRatingDialogApprove: Approve
    Approve Creatives: Approve Creatives
    approveProject: Approve Project
    approveProjectModalTitle: Approve Project?
    approveProjectModalBody: Your project will be completed and you will no longer be able to add any revisions. Approved projects can be exported and downloaded.
    Business account: Business account
    continueProductionBtn: Continue Production
    continueProductionModalTitle: Continue Production?
    continueProductionModalBody: Our designers will move onto the next stage of your project, during this time no further revisions can be added. You will receive an email when your creative is ready to review.
    Download: Download
    downloadAll: Download All
    downloadAsZip: Download as .zip
    exportMenu: Export
    Modal: Modal
    Order Now: Start Project
    Playdeck: Playdeck
    Select a business account: Select a business account
    View Demo: View Demo
    View Playdeck: View Playdeck
    accessRevoked: Access was revoked.
    afterClickingApprove: 'After clicking <i>Approve Creatives</i>, you will no longer be able to request revisions.'
    approveAndProceedBtn: Approve & Proceed
    automaticOrderApprovalText: 'This project will automatically be approved {{ when }}.'
    chooseExistingFolder: Choose an existing folder
    close: Close
    conceptNameLabel: 'Concept {{conceptNumber}}:'
    confirmInternalDeliveryModalBtnText: Deliver Creatives
    confirmInternalDeliveryModalText: 'Once you click <i>Deliver Creatives</i>, the project will be delivered to the client and you will no longer be able to request internal revisions.'
    confirmInternalDeliveryModalTitle: Are you sure?
    confirmRequestInternalRevisionModalBtnText: Request Internal Revision
    confirmRequestInternalRevisionModalDirectiveText: Please communicate any delivery delays accordingly to manage customer expectations.
    confirmRequestInternalRevisionModalText: 'Once you click <i>Request Internal Revision</i>, you will be redirected to the review link to add your internal revision comments. Once you are done, move the Trello card to <i>Revision Needed</i> so production can start processing your request.'
    confirmRequestInternalRevisionModalTitle: Internal Revision Process
    continue: Continue
    copyLink: Link copied to clipboard
    copyVariationNumber: 'Copy variation {{copyVariationNumber}}'
    createNewFolder: Create a new folder
    creativeFolder: Creative folder
    deliverableBadgeApproved: Hero Approved
    deliverableBadgeAwaiting: Awaiting review
    deliverableBadgeRevision_one: '{{revisionNumber}} revision'
    deliverableBadgeRevision_other: '{{revisionNumber}} revisions'
    dropboxExportComplete: Dropbox export succeeded.
    emailInstructions: Email Instructions
    errorNoVideos: 'Sorry, this order does not contain any video creatives (only images), so we cannot export it to Youtube'
    exportCompleted: Export finished
    exportCurrentlyCreatingDeliverablesText: 'We are currently creating your download zip file, please check back shortly.'
    exportError: 'Export error. {{error}}.'
    exportProgress: 'Exporting deliverables {{progress}}%'
    exportSpinnerText: 'Exported {{successCount}} of {{totalCount}} deliverables'
    formatNameSelectOptionsTitle: Formats
    frameIOUrlBtn: Add revision comments in frame.io
    googleAdsAccount: Google Ads Account
    hero: Hero
    baseCopy: Base Copy
    inProgressText: Your project has moved to the next production stage. You will receive an email when your next set of creatives are ready to review.
    internalDeliveryButtonLabel: Deliver Creative
    internalDeliveryModalTitle: Deliver Creative?
    internalDeliveryModalBody: The project will be delivered to the client and you will no longer be able to request internal revisions. Please communicate any delivery delays accordingly to manage customer expectations.
    internalDeliveryRequestRevision: Request internal revision
    internalDeliveryRevisionInProgress: Internal revision in progress
    languageSelectOptionsTitle: Languages
    letsGoText: Let's go!
    linkCopied: The link has been copied to your clipboard.
    modalDeleteCancelButton: Cancel
    mustBeLoggedInToApproveText: but you must be logged in to approve the project.
    newFolderName: New folder name
    noMatchingCreatives: There are no matching Creatives, please try different filters.
    numHeroesRevised_one: '{{numRevisionRequests}} hero has revisions.'
    numHeroesRevised_other: '{{numRevisionRequests}} of {{numHeroes}} heroes have revisions.'
    numHeroPendingReview_one: '{{numHeroPendingReview}} hero is awaiting review.'
    numHeroPendingReview_other: '{{numHeroPendingReview}} of {{numHeroes}} heroes are awaiting review.'
    orderApproveActionsText: 'Once you approve this project, you will have access to your creatives.'
    orderConfirmationText: 'Once you approve these creatives, your project will move to the next stage, and your next set of creatives will be produced and delivered to you. You will not be able to request revisions for these creatives once your project moves to the next stage.'
    orderNumber: ' #{{orderNumber}}'
    orderStateLabel: 'Status:  <1>{{orderState}}</1>'
    proceedToProduction: Proceed to full production
    proceedToProductionDialogTitle: Are you sure?
    proceedToProductionDialogDescription: Once you approve these creatives, your project will move to the next stage, and your next set of creatives will be produced and delivered to you. You will not be able to request revisions for these creatives once your project moves to the next stage.
    requestChangesText: . Please contact your <1>client partner</1> to request any further changes.
    requestRevision: Request Revision
    removeFilterBtnLabel: 'Remove Filters ({{totalFilters}})'
    reviewBtnLabel: 'Review'
    revisionCommentInfoText: 'Please note: Your revision may already be in progress. If you have added additional comments please let your account manager know.'
    revisionConfirmationText: Your project is under revision. You will receive an email once your revisions are complete.
    revisionRequestConfirmationBtn: Request a Revision
    revisionRequestConfirmationText: Provide clear and actionable comments for our design team to accurately process your revisions. If you would like to make major changes please contact your Creative Specialist.
    revisionRequestConfirmationTitle: Are you sure?
    revisionRequestFrameIoBtn: Frame.io
    revisionRequestFrameIoLink: New to Frame.io? Here's how it works
    revisionRequestHeading: Request a revision on your project
    revisionRequestStep1Description: Start by clicking the <strong>Frame.io</strong> link below to view your creatives.
    revisionRequestStep1Label: Step 1 - Go to Frame.io
    revisionRequestStep2Description: Comment and draw on specific parts of the video where you’d like to make a revision.
    revisionRequestStep2Label: Step 2 - Give us feedback
    revisionRequestStep3Description: 'Once you’re done, come back to this page and click <strong>Submit Revision</strong>'
    revisionRequestStep3Label: Step 3 - Submit Revision
    revisionRequestSubHeading: Make sure everything is in check before we package up your winning campaign
    revisionRequestSubmitRevision: Submit Revision
    revisionSubmitConfirmationModalBtn: Submit Revision
    revisionSubmitConfirmationModalText: Once you click <strong><i>Submit Revision </i></strong> this will notify Shuttlerock to start working on the requests. No further comments or edits can be made to Frame.io.
    revisionSubmitConfirmationModalTitle: Are you sure?
    revokeAccessToMyYoutubeAccount: Revoke access to my account
    resultFilters: 'Results ({{numOfResults}})'
    seconds: seconds
    selectAnAdvertiser: Select an advertiser
    selectFolder: Select a Folder
    sendExportInstructionsToSomeoneElse: Send export instructions to someone else
    sendInstructionsToSomeoneElse: Send instructions to someone else
    sentToProduction_one: '{{numRevisionRequests}} deliverable will be sent to production'
    sentToProduction_other: '{{numRevisionRequests}} deliverables will be sent to production'
    shareUrlButtonText: 'Share'
    sortAndFilterMenuTitle: Filter
    submitRevisions: Submit Revisions
    unitNumber: 'Unit {{unitNumber}}'
    viewBriefSummary: Project Brief
    viewBtnLabel: View
    wouldYouLike: Would you like to email these links to your team?
    youDontHaveGoogleAdsAccount: You don't have Google Ads account
    youHaveWithCount_one: '{{revisionLeft}} of {{maxNumRevisions}} revision remaining'
    youHaveWithCount_other: '{{revisionLeft}} of {{maxNumRevisions}} revisions remaining'
    youtubeMenuModalHeading: How would you like to export your deliverables?
  orderDeliverableUpload:
    activeAdmin: 'Active Admin:'
    cannotAddDeliverableErrorDesc: Deliverables can no longer be uploaded for this order.
    cannotAddDeliverableErrorTitle: 'This page is no longer accessible:'
    conceptOptionLabel: 'Concept {{number}} - {{name}}'
    conceptHeaderLabel: 'Concept'
    confirmDelete: Delete
    confirmDeleteText: Are you sure you want to delete this deliverable?
    confirmDeleteTitle: Destroy deliverable?
    containsAiHeaderLabel: Contains AI
    containsAiHeaderTooltip: Select yes if any asset (image, audio, video or music) used in this concept was primarily generated, or significantly edited (such as background generation, product placements etc.), using an AI model service provider (such as Midjourney, Luma AI, ElevenLabs or Sora).
    currentState: 'Current State:'
    currentWorkflowStep: 'Current Workflow Step:'
    deletePermissionError: Sorry, you don’t have permission to archive this deliverable.
    deliverableFormatHeaderLabel: Format
    deliverableNameHeaderLabel: Deliverable Name
    deliverableExportNameHeaderLabel: Export Filename
    deliverableFormat: Deliverable Format
    deliverableFormatErrorRequired: Please enter the valid format for this deliverable
    deliverableName: Deliverable Name
    deliverables: Deliverables
    deliveryPageLink: 'Delivery Page Link:'
    duplicateFileFoundDialogTitleDeprecated: 'Duplicate File Found'
    duplicateFileFoundDialogContentDeprecated: 'A file you are attempting to upload has the same file attributes as file “{{fileName}}” which is already uploaded to this project. Do you want to replace this file with the one you are uploading?'
    duplicateFileFoundDialogActionReplaceDeprecated: 'Replace File'
    duplicateFileFoundDialogActionCancelDeprecated: Cancel
    duplicateFileFoundDialogTitle: 'Duplicate Files'
    duplicateFileFoundDialogContent: Multiple files with identical set of attributes have been detected.
    duplicateFileFoundDialogNew: New
    duplicateFileFoundDialogExisting: Existing
    duplicateFileFoundDialogActionContinue: Continue
    duplicateFileFoundDialogActionProceed: Proceed
    duplicateFileFoundDialogActionCancel: Cancel
    duplicateFileFoundDialogOptionUploadNewVersionTitle: Upload new file as a new version
    duplicateFileFoundDialogOptionUploadNewVersionDescription: The new file will be stacked as a new version against the existing.
    duplicateFileFoundDialogOptionKeepOriginalTitle: Keep original & discard new
    duplicateFileFoundDialogOptionKeepOriginalDescription: No change. The new file will be discarded.
    duplicateFileFoundDialogOptionKeepBothTitle: Keep both
    duplicateFileFoundDialogOptionKeepBothDescription: Both files will be kept. A ‘Unit’ number will be added to the new file.
    durationHeaderLabel: Duration
    failedUpload: Failed upload
    failedUploadUnsupported: Failed to upload - unsupported file type.
    bitrate: '{{bitrate}}kbps'
    fps: '{{fps}}fps'
    fileTypeHeaderLabel: File Type
    heightHeaderLabel: Height
    heroLabel: 'Hero {{position}}'
    heroHeaderLabel: Hero
    languageHeaderLabel: Language
    localeHeaderLabel: Locale
    loading: Loading
    lockedTooltip: Approved
    measurementUnitHeaderLabel: Measurement Unit
    audioUrlHeaderLabel: Audio URL
    amplifyLinkHeaderLabel: Amplify Link
    newAssetLabel: Upload files for this project
    newAssetHelperText: Drop or browse files. We’ll try to match them to their deliverables automatically. You can adjust matches manually before saving.
    nextWorkflowStep: 'Next Workflow Step:'
    originalCreativeOptionLabel: Original Creative
    platformHeaderLabel: Platform
    revisionHeaderLabel: Revision
    workingFiles:
      title: Working files
      uploadedCount: '{{count}} Successfully uploaded.'
      downloadAll: Download all
      helperText: 'Optional: upload editable or layered files (e.g., PSD, AE) if recipients will be doing their own edits.'
      columnHeadings:
        filename: Name
        uploader: Uploaded by
        uploadedAt: Date uploaded
        size: Size
      empty: No files
    footerHelperText: When you save, your files will appear in the Review tab, ready for approval.
    saveButton: Save
    saveOrderBtn: Save Project
    saved: The project has been saved
    state: State
    title: Upload Deliverables
    titleErrorRequired: This field is required.
    unitHeaderLabel: Unit
    uploadErrorText: ' {{uploadErrorCount}} missing mandatory fields.'
    uploadAudioUrlInvalidText: ' {{audioUrlInvalidCount}} invalid Audio URLs.'
    uploadDeliverableFileNameInvalid_one: ' {{count}} deliverable file name has unsupported characters.'
    uploadDeliverableFileNameInvalid_other: ' {{count}} deliverable file names have unsupported characters.'
    uploadDeliverableFileExtensionInvalid_one: " {{count}} deliverable file name extension doesn't match the original."
    uploadDeliverableFileExtensionInvalid_other: " {{count}} deliverable file name extensions don't match the original."
    uploadHeroMissingText: ' Concept {{heroMissingConcepts}} needs a Hero defined.'
    uploadSuccessText: ' {{uploadSuccessCount}} Successfully uploaded.'
    variantHeaderLabel: Variant
    versionHeaderLabel: Version
    widthHeaderLabel: Width
    yes: Yes
    utility:
      assistant: Assistant
      overview: Overview
      summary: Summary
    containsAIOptions:
      YES: Yes, contains AI
      NO: No
      UNSURE: Not sure
    audioTypeNoAudio: No background music
    audioTypeClientProvided: Client provided audio
    amplifyLink:
      linkTemplate: Link Template
      conceptName: Concept {{position}} - {{name}}
      reload: Reload
      viewInAmplify: View in Amplify
      replace: Replace
      matchedCompCount: '{{count}} comp matched with Formats'
      matchingCompNotFound: Matching Comp not found
      renderingDeliverables: Rendering deliverables ({{renderedCount}}/{{totalCount}} done)...
      linkATemplate: Link a template
      amplifyTemplateID: Amplify Template ID
      amplifyTemplateIDRequired: Amplify Template ID is required
      amplifyTemplateLinkSuccessMsg: Started fetching deliverables from Amplify, which might take a while. Refresh the page to see updates.
    amplifyTemplateImport:
      importFromAmplifyTemplate: Import from Amplify Template
      import: Import
      revisions: Revisions
      revision: Revision {{versionNumber}}
      compositions: Compositions
      compositionsRequired: At least one composition must be selected
      templateName: 'Name: {{name}} ({{id}})'
      templateNotFound: Template not found
      amplifyTemplateID: Amplify Template ID
      amplifyTemplateIDRequired: Amplify Template ID is required
      templateImportSuccessMsg: The compositions of the template have been successfully imported.
      next: Next
      back: Back
      finish: Finish
    newVariantOption: '+ New variant'
    createVariantDialog:
      title: Create new variant
      titleWithConcept: 'Create new variant — {{conceptName}}'
      sequenceLabel: Variant number
      sequenceRequired: Variant number is required
      sequenceInvalid: Must be a whole number
      sequenceMin: Must be 0 or greater
      sequenceDuplicate: This variant number already exists
      nameLabel: Name
      nameRequired: Name is required
      namePlaceholder: Enter variant name
      createButton: Create
    batchNameVariantsDialog:
      title: Name new variants
      variantLabel: 'Variant {{sequence}}'
      nameRequired: Name is required
      placeholder: Enter variant name
      saveButton: Save
  orderList:
    actionFilterBtnLabel: 'Filter ({{totalFilters}})'
    brandsSelectOptionsTitle: Brands
    clientPartnersSelectOptionsTitle: Client Partners
    clientsSelectOptionsTitle: Clients
    creativeSpecialistsSelectOptionsTitle: Creative Specialists
    groupsSelectOptionsTitle: Groups
    regionsSelectOptionsTitle: Regions
    removeFilterBtnLabel: 'Remove Filters ({{totalFilters}})'
    resultFilters: 'Results ({{numOfResults}})'
    salesTerritorySelectOptionsTitle: Sales Territory
    searchPlaceholder: Search
    sortAndFilterMenuTitle: Filter
    statusGroupTitle: Status
    statusPlaceholder: Any Status
    title: Project Tracker
  orderListTable:
    actions: Actions
    actionsAdjustRevisions: Adjust Revision Limit
    actionsBtnAriaLabel: Open Order Action Menu
    actionsConfirmOrder: Approve Brief
    actionsContinueOrder: Continue Project
    actionsDelete: Delete
    actionsReorder: Re-order
    actionsReviewCreatives: Review Creatives
    actionsViewCreatives: View Creatives
    addDeliverablesLabel: Add Deliverables
    brand: Brand
    briefSummaryLabel: Brief Summary
    cancelBtn: Cancel
    client: Client
    customOrderLabel: Custom Order
    emptyTableMessage: There are no projects to display. Click the 'New Project' button above to start a new project.
    maxNumRevisionsLabel: Max. Number of Revisions
    maxNumRevisionsPlaceholder: Set the number of revisions
    modalAdjustRevisionsTitle: 'Set maximum number of revisions for {{workflowStep}} Step'
    modalConfirmOrderTitle: Are you sure you want to approve this brief?
    modalDeleteCancelButton: Cancel
    modalDeleteConfirmationButton: Delete Project
    modalDeleteConfirmationText: This project will be removed. Are you sure you want to continue?
    modalDeleteConfirmationTitle: Are you sure?
    orderName: Project Name
    orderNumber: 'Project Number: {{serialId}}'
    productionBriefLabel: Production Brief
    status: Status
    submitBtn: Adjust Revision Limit
    successDeleteContent: Your project has been successfully deleted.
    successDeleteHeader: Draft deleted
  orderState:
    cs_review: CS Review
    ugc_ideation: UGC ideation
    asset_production: Asset production
  orderSummary:
    Back: Back
    Edit: Edit
    Update: Update
    cancelBtn: Cancel
    orderNotificationTitle: Who should receive notifications when this project is ready?
    submitBtn: Submit Your Project
  orderingSidebar:
    brandAssetsTitle: Brand Assets
    campaignDetailsTitle: Campaign Details
    conceptVariations_one: '{{count}}x Concept Variation'
    conceptVariations_other: '{{count}}x Concept Variations'
    reviewMyOrder: Review My Order
    title: Summary
    tooltipMessage: There are mandatory fields that are missing answers
    translationVariations_one: '{{count}}x Translation Variation'
    translationVariations_other: '{{count}}x Translation Variations'
  passwordStrength:
    Password Strength: Password Strength
  previewBox:
    audio: Audios
    brand: Brand
    compressed: Zip
    caption: Preview box
    font: Fonts
    logo: Logos
    music: Music
    stills: Images
    video: Video
  priceList:
    title: Pricing
  productCategory:
    blank_category: '---'
    image_to_video: Image to Video
    multi_channel_videos: Multi Channel Videos
    multiple_images_to_video: Multiple Images to Video
    tvc_to_video: TVC to Video
    up_to_15_second_videos: Up to 15 Second Videos
    up_to_30_second_videos: Up to 30 Second Videos
    up_to_6_second_videos: Up to 6 Second Videos
    video_and_images: Video and Images
    video_only: Video Only
  questionForm:
    questionErrorRequired: This is a required question
  salesTerritories:
    ANZ: Australia & New Zealand
    ASIA: Asia & Pacific
    DELTA: DELTA
    EMEA: 'Europe, Middle East & Africa'
    JAPAN: Japan
    NAM: North America
    UKI: United Kingdom & Ireland
    VIDMOB: VidMob
  setPassword:
    description: 'Please enter a new password for your account:'
    passwordErrorRequired: Password cannot be empty
    passwordLabel: Password
    passwordPlaceholder: Enter a new password
    passwordLengthMessage: Password must be at least 12 characters.
    resetPasswordBtn: Reset your password
    signUpBtn: Submit
    title: Set your password
    expiredTitle: Password reset expired
    expiredDescription: Please request a new password reset link
    expiredWarningTitle: This link is no longer valid
    expiredWarningContent: "The requested 'reset password' link has either timed out or already been used. Please submit your email again to generate a new one."
    resubmitBtn: Resubmit Email
  signUpForm:
    back: Back
    emailErrorEmail: This should be an email
    emailErrorRequired: This field is required.
    emailLabel: Email Address
    emailPlaceholder: ' '
    firstNameErrorRequired: This field is required.
    firstNameLabel: First Name
    firstNamePlaceholder: First Name
    heading: Sign Up
    lastNameErrorRequired: This field is required.
    lastNameLabel: Last Name
    lastNamePlaceholder: Last Name
    passwordErrorRequired: This field is required.
    passwordLabel: Password
    passwordPlaceholder: ' '
    passwordLengthMessage: Password must be at least 12 characters.
    rememberMeLabel: Remember me
    signUpBtn: Sign Up
    signUpConfirmationText: 'An email has been sent to {{email}}'
    signUpConfirmationTitle: Thanks for signing up!
  signUpGettingStarted:
    alreadyHaveAccount: Already have an account?
    continueWithEmail: Continue with Email
    continueWithFacebook: Continue with Facebook
    continueWithGoogle: Continue with Google
    heading: Get Started!
    signIn: ' Sign in'
  submissionStateErrorModal:
    campaignDetails: Campaign Details
    description: Come back to the Brief Summary when you're ready to resubmit.
    missingInformation: 'You are missing mandatory information on the following pages:'
    return: Return To Brief Summary
    title: Looks like your brief is incomplete!
  toast:
    saveAndExitOrderBriefDescription: Your brief has been successfully saved and will be waiting for you when you come back.
    saveAndExitOrderBriefTitle: Your brief has been saved!
  translatable:
    inputPlaceholder: Type your answer here...
  unconfirmedEmail:
    body: 'We’ve sent you an email to confirm your account, please open this and click the link. Didn’t receive an email? <1>Resend Confirmation</1>'
    heading: Unconfirmed email
  uploadElement:
    uploaderErrorMessage: 'There was an error when displaying the uploader, please contact the administrator.'
  uploader:
    file: a file
    fileLimitHitWithCount_one: 'You can only upload {{count}} file'
    fileLimitHitWithCount_other: 'You can only upload {{count}} files'
    file_other: files
    noMoreFilesMessage: You cannot upload any more files
    uploaderText: 'Drag and drop {{files}} here or click to open your file browser'
  userInvite:
    cancelBtn: Cancel
    copyInviteLink: Copy Invite Link
    emailErrorRequired: The email is required
    emailLabel: Email
    emailPlaceholder: joe@example.com
    firstNameLabel: First name
    firstNamePlaceholder: Joe
    lastNameLabel: Last name
    lastNamePlaceholder: Smith
    modalContent: 'Send an automatic email inviting the user to Shuttlerock Cloud, or copy the invitation link.'
    modalHeader: Invite the user
    sendInviteEmail: Send Invite Email
    submitBtn: Create User
    userCreatedWithEmail: User account has been created and Shuttlerock Cloud invite email sent
    userCreatedWithoutEmail: The user has been created and the Shuttlerock Cloud invite link has been copied to your clipboard
  userList:
    actions: Actions
    actionsBtnAriaLabel: Open user action menu
    actionsCopyInviteLink: Copy Invite Link
    actionsResendInvite: Resend Invite
    actionsSendInvite: Send Invite
    copyInviteLinkSuccess: Shuttlerock Cloud invite link has been copied to your clipboard
    email: Email
    emptyTableMessage: There are no users to display. Click the 'New User' button above to add a new user.
    invitationStatus: Invitation Status
    inviteAccepted: 'Invite accepted at {{at}}'
    inviteCreated: 'Invite created at {{at}}'
    inviteSent: 'Invite sent at {{at}}'
    newUser: New User
    notInvited: Not invited
    resendInviteSuccessMessage: 'The email invite has been resent to {{email}}'
    sendInviteSuccessMessage: 'The email invite has been sent to {{email}}'
    userName: User Name
  verticals:
    Agency - Global: Agency - Global
    Agency - Independent: Agency - Independent
    App Install: App Install
    Automotive: Automotive
    Beverages: Beverages
    Charities & Organisations: Charities & Organisations
    Consumer Goods: Consumer Goods
    Cosmetics & Luxury: Cosmetics & Luxury
    CPG: CPG
    Disruptors: Disruptors
    ECom: ECom
    eCommerce: eCommerce
    Education: Education
    Energy & Utilities: Energy & Utilities
    Entertainment: Entertainment
    Entertainment & Media: Entertainment & Media
    Financial Services: Financial Services
    FinServ: FinServ
    FinTech: FinTech
    Food and Beverage: Food and Beverage
    Gaming: Gaming
    Government & Politics: Government & Politics
    Health & Fitness: Health & Fitness
    Health & Pharmaceuticals: Health & Pharmaceuticals
    Healthcare: Healthcare
    Organization & Associations: Organization & Associations
    Other: Other
    Professional Services: Professional Services
    Restaurants: Restaurants
    Retail: Retail
    Services: Services
    Social Commerce: Social Commerce
    Sports & Fitness: Sports & Fitness
    Technology: Technology
    Tech & Telecommunications: Tech & Telecommunications
    Telecommunications: Telecommunications
    Travel: Travel
    Travel & Leisure: Travel & Leisure
